export default {"src":"/_next/static/media/calendar.27699cdd.svg","height":513,"width":513};